export const SearchTypeSavedSearch = 24 as const;
export type TSearchTypeSavedSearch = typeof SearchTypeSavedSearch;
